// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  trackingId: "UA-118903825-1",
  api : "https://auth.esp-staging.omnissa-aws.com/api/auth/v1",
  espApi: "https://configmax-dev.esp-staging.eng.omnissa.com/api/",
  apiLogoutUrl: 'https://auth.esp-staging.omnissa-aws.com/api/auth/v2/logout',
  ssoURL : "https://myvmware-stg.workspaceair.com/SAAS/API/1.0/GET/apps/launch/app/aaa20196-48b0-4c54-b9aa-b1ba7ae3939f",
  clientId : "esp-stg-428-nwzpw",
  state: "t3jbMJNi",
  authApiUrl: "https://authorization.esp.omnissa.com/api/authorize/v1/permissions/check?client_id=esp-stg-428-nwzpw",
  espClientId: "configmax-client",
  redirectUri: "/login/auth",
  empAdUrl: "https://employee-ad.esp-staging.eng.omnissa.com/",
  localizationFilesPath: "https://whitney-dev.esp-staging.eng.omnissa.com/configurationapi/v1/configmax/labels/supportedvalues?locale=",
  whitneyUrl: "https://whitney-dev.esp-staging.eng.omnissa.com/",
  whitneyAssetsUrl: "https://whitney-dev.esp-staging.eng.omnissa.com/configurationapi/assetsapi/v1/configmax/asset/"
};



// WEBPACK FOOTER //
// ./src/environments/environment.dev.ts